import { motion } from 'framer-motion'
import { Button } from '#app/components/ui/button.tsx'

export function AIAssistantButton({ onClick }: { onClick: () => void }) {
	return (
		<Button
			onClick={onClick}
			className="group fixed bottom-8 left-1/2 z-50 size-16 -translate-x-1/2 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 p-0 shadow-xl transition-all duration-200 hover:from-blue-600 hover:to-purple-700 hover:shadow-2xl"
			aria-label="Open AI Assistent"
		>
			<motion.div
				className="relative flex size-full items-center justify-center"
				whileHover={{ scale: 1.05 }}
				whileTap={{ scale: 0.95 }}
			>
				{/* Animated sound wave orb */}
				<div className="absolute inset-0 flex items-center justify-center">
					<motion.div
						className="absolute size-full rounded-full bg-white/10"
						animate={{
							scale: [1, 1.2, 1],
							opacity: [0.3, 0.1, 0.3],
						}}
						transition={{
							duration: 2,
							repeat: Infinity,
							ease: 'easeInOut',
						}}
					/>
					<motion.div
						className="absolute size-full rounded-full bg-white/10"
						animate={{
							scale: [1, 1.3, 1],
							opacity: [0.2, 0.05, 0.2],
						}}
						transition={{
							duration: 2,
							repeat: Infinity,
							ease: 'easeInOut',
							delay: 0.5,
						}}
					/>
				</div>

				{/* Center icon */}
				<div className="relative size-8 text-white">
					<svg
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
						className="size-full"
					>
						{/* Sound wave icon */}
						<path d="M12 2v20" />
						<path d="M8 7v10" />
						<path d="M4 10v4" />
						<path d="M16 7v10" />
						<path d="M20 10v4" />
					</svg>
				</div>
			</motion.div>
		</Button>
	)
}
